export const EVENT_BATCH_LIST = 'EVENT_BATCH_LIST';
export const EVENT_BATCH_LIST_SUCCESS = 'EVENT_BATCH_LIST_SUCCESS';
export const EVENT_BATCH_LIST_ERROR = 'EVENT_BATCH_LIST_ERROR';

export const ADD_BATCH = 'ADD_BATCH';
export const ADD_BATCH_SUCCESS = 'ADD_BATCH_SUCCESS';
export const ADD_BATCH_ERROR = 'ADD_BATCH_ERROR';

export const EDIT_BATCH = 'EDIT_BATCH';
export const EDIT_BATCH_SUCCESS = 'EDIT_BATCH_SUCCESS';
export const EDIT_BATCH_ERROR = 'EDIT_BATCH_ERROR';

export const BATCH_DETAILS = 'BATCH_DETAILS';
export const BATCH_DETAILS_SUCCESS =  'BATCH_DETAILS_SUCCESS';
export const BATCH_DETAILS_ERROR = 'BATCH_DETAILS_ERROR';

export const DELETE_BATCH = 'DELETE_BATCH';
export const DELETE_BATCH_SUCCESS = 'DELETE_BATCH_SUCCESS';
export const DELETE_BATCH_ERROR  = 'DELETE_BATCH_ERROR';

export const EVENTVERIFIER_LIST = 'EVENTVERIFIER_LIST';
export const EVENTVERIFIER_LIST_SUCCESS = 'EVENTVERIFIER_LIST_SUCCESS';
export const EVENTVERIFIER_LIST_ERROR = 'EVENTVERIFIER_LIST_ERROR';

export const EVENTVERIFIER_LIST_DETAILS = 'EVENTVERIFIER_LIST_DETAILS';
export const EVENTVERIFIER_LIST_DETAILS_SUCCESS = 'EVENTVERIFIER_LIST_DETAILS_SUCCESS';
export const EVENTVERIFIER_LIST_DETAILS_ERROR = 'EVENTVERIFIER_LIST_DETAILS_ERROR';

export const DELETE_EVENTVERIFIER_LIST = 'DELETE_EVENTVERIFIER_LIST';
export const DELETE_EVENTVERIFIER_LIST_SUCCESS = 'DELETE_EVENTVERIFIER_LIST_SUCCESS';
export const DELETE_EVENTVERIFIER_LIST_ERROR = 'DELETE_EVENTVERIFIER_LIST_ERROR';


